<template>
    <div>
        <div class="flex min-h-screen w-full flex-col justify-between pt-16 lg:pt-24">
            <slot />
        </div>
    </div>
</template>
